import http from '../httpService';


export function createExitStrategyForm(payload) {
  return http.post('/exit-strategy-forms', payload);
}
export function editExitStrategyForm(id,payload) {
  return http.put(`/exit-strategy-forms/${id}`,payload)
}
export function getExitStrategyForm(id) {
  return http.get(`/exit-strategy-forms?cycleId.equals=${id}`)
}